<template>


  <div class="">

    <div class="row mb-3">
      <div class="col-lg col-md-6   mx-2 my-2 ">
        <div class="stat-block">
          <span>{{ $t('conditionMonitoring.power.totalkvah') }}</span>
          <h3>{{ formatNumber(round(getTotal('totalKvaH'), 2)) }} kVAh</h3>
        </div>
      </div>
      <div class="col-lg col-md-6   mx-2 my-2 ">
        <div class="stat-block">
          <span>{{ $t('conditionMonitoring.power.totalProductionTime') }}</span>
          <h3>{{ getTotalProductionTime }}</h3>
        </div>
      </div>
      <div class="col-lg col-md-6   mx-2 my-2 ">
        <div class="stat-block">
          <span>{{ $t('conditionMonitoring.power.averagePower') }}</span>
          <h3>{{ formatNumber(round(getAverage('kva.avg'), 2)) }}</h3>
        </div>
      </div>
      <div class="col-lg col-md-6   mx-2 my-2 ">
        <div class="stat-block">
          <span>{{ $t('conditionMonitoring.power.averageKvaKg') }}</span>
          <h3>{{ formatNumber(round(getAverage('kvahPerKg'), 2)) }}</h3>
        </div>
      </div>
      <div class="col-lg col-md-6   mx-2 my-2 ">
        <div class="stat-block">
          <span>{{ $t('conditionMonitoring.power.averagePowerfactor') }}</span>
          <h3>{{ formatNumber(round(getAverage('powerFactor.avg'), 2)) }}</h3>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12">
        <ve-table
            :max-height="'80vh'"
            :min-height="'100%'"
            :fixed-header="true"
            :expand-option="expandOption"
            :border-y="true"
            row-key-field-name="rowKey"
            :columns="getColumns"
            :cellSelectionOption="cellSelectionOption"

            :row-style-option="rowStyleOption"
            :table-data="getRowsSorted"/>
      </div>
    </div>
  </div>

</template>

<script>
import ChildTable from "@/components/conditionMonitoring/power/ChildTable";
import {mapGetters} from "vuex";
import timeCalc from "@/mixins/timeCalc";
import { formatNumber, round } from '@/filters/filters';

export default {
  name: "Electricity",
  props: ['filter'],
  mixins: [timeCalc],
  components: {
    ChildTable
  },
  data() {
    return {
      columnWidths: {
        firstColumn: '15%',
        minkva: '6%',
        maxkva: '6%',
        avgkva: '6%',
        kvahPerKg: '7%',
        powerFactor: '7%',
      },
      productionRuns: [],
      virtualScrollOption: {
        enable: true,
      },
      rowStyleOption: {
        stripe: false,
        clickHighlight: false,
        hoverHighlight: false,
      },
      cellSelectionOption: {
        enable: false,
      },
      expandOption: {
        trigger: "row",
        expandable: true,
        render: ({row, column, rowIndex}, h) => {
          return <ChildTable columnWidth={this.columnWidths} index={rowIndex} row={row}/>;
        },
      }
    }
  },
  computed: {
    ...mapGetters('workflows', ['getWorkflowName']),
    ...mapGetters('company', ['getProductNumberKey', 'getNpcKey']),
    getRowsSorted() {
      let mappedData = _.map(this.getGrouppedRuns, (run, idx) => {

        return {
          rowKey: idx,
          productNumber: idx,
          productDescription: run[0].additionalData.productDescription,
          powerFactor: {
            avg: _.meanBy(run, 'powerFactor.avg'),
            min: _.minBy(run, 'powerFactor.min').powerFactor.min,
            max: _.maxBy(run, 'powerFactor.max').powerFactor.max
          },
          kva: {
            avg: _.meanBy(run, 'kva.avg'),
            min: _.minBy(run, 'kva.min').kva.min,
            max: _.maxBy(run, 'kva.max').kva.max
          },
          kvahPerKg: isNaN(_.meanBy(run, 'kvahPerKg')) ? 0 : _.meanBy(run, 'kvahPerKg'),
          productionRuns: run
        }


      })

      return mappedData
    },
    getGrouppedRuns() {
      return _.groupBy(this.productionRuns, 'additionalData.productNumber')

    },
    getColumns() {
      return [
        {
          field: null,
          key: 'c1',
          title: this.$t('conditionMonitoring.productNumber'),
          type: "expand",
          align: "left",
          width: this.columnWidths.firstColumn,
          // fixed: 'left',
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return row.productNumber
          }
        },
        {
          field: null,
          key: "c2",
          title: this.$t('conditionMonitoring.productDescription'),
          align: "left",
          // fixed: 'left',
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return row.productDescription
          }
        },
        {
          field: null,
          key: "c5",
          title: this.$t('conditionMonitoring.math.min') + this.$t('conditionMonitoring.power.kva'),
          align: "left",
          sortBy: '',
          width: this.columnWidths.minkva,
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return formatNumber(_.round(row.kva.min, 2)) + ' ' + this.$t('conditionMonitoring.power.kva')
          }
        },
        {
          field: null,
          key: "c6",
          title: this.$t('conditionMonitoring.math.max') + this.$t('conditionMonitoring.power.kva'),
          align: "left",
          sortBy: '',
          width: this.columnWidths.maxkva,
          renderBodyCell: ({row, column, rowIndex}, h) => {

            return formatNumber(_.round(row.kva.max, 2)) + ' ' + this.$t('conditionMonitoring.power.kva')

          }
        },
        {
          field: null,
          key: "c7",
          title: this.$t('conditionMonitoring.math.avg') + this.$t('conditionMonitoring.power.kva'), align: "left",
          sortBy: '',
          width: this.columnWidths.avgkva,
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return formatNumber(_.round(row.kva.avg, 2)) + ' ' + this.$t('conditionMonitoring.power.kva')
          }
        },
        {
          field: null,
          key: "c8",
          title: this.$t('conditionMonitoring.power.kvaKg'),
          align: "left",
          sortBy: '',
          width: this.columnWidths.kvahPerKg,
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return formatNumber(_.round(row.kvahPerKg, 2)) + ' ' + this.$t('conditionMonitoring.power.kvaKg');
          }
        },
        {
          field: null,
          key: "c9",
          title: this.$t('conditionMonitoring.power.powerFactor'),
          align: "left",
          width: this.columnWidths.powerFactor,
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return formatNumber(_.round(row.powerFactor.avg, 2))
          }

        },

      ]
    },
    getTotalProductionTime() {
      return this.formattedColonTime(
          _.sumBy(this.productionRuns, run => {
            let diff = moment(run.productionEnd ? run.productionEnd : moment()).diff(run.productionStart)
            return diff
          }))
    }


  },
  methods: {
    formatNumber,
    round,
    getAverage(key) {
      let avg = _.meanBy(this.productionRuns, key)
      return isNaN(avg) ? 0 : avg
    },
    getTotal(key) {
      let total = _.sumBy(this.productionRuns, key)
      return isNaN(total) ? 0 : total
    },
    getExportableData(runs) {
      return _.map(runs, run => {

        return {
          activity: run.activity,
          productionRunId: run.id,
          jobId: run.jobId,
          powerFactorMin: run.powerFactor.min,
          powerFactorMax: run.powerFactor.max,
          powerFactorAvg: run.powerFactor.avg,
          kvaMin:run.kva.min,
          kvaMax:run.kva.max,
          kvaAvg:run.kva.avg,
          productNumber:run.productNumber,
          productDescription: run.productDescription,
          workflow:this.getWorkflowName(run.workflowId),
          totalKvah:run.totalKvaH,
          totalKwH:run.totalKwH,
          pph:run.pph,
          pphActual:run.pphActual,
          productionStart:run.productionStart,
          productionEnd:run.productionEnd


        }
      })
    },
    async getProductionRuns() {
      let query = {
        fromDate: moment(this.filter.dateRange[0]).startOf('date').toISOString(),
        toDate: moment(this.filter.dateRange[1]).endOf('date').toISOString(),
        workflowIds: this.filter.workflows
      }
      let productionRuns = await this.$FUNCTIONS.ConditionMonitoring("getProductionRuns", query).catch(e => {

      })
      if (!productionRuns.data) {
        this.productionRuns = []
      }
      productionRuns = _.map(productionRuns.data, run => {
        if (true) {
          // get key and valuye of weight CHECK IN CONFIG
          let productWeight = parseInt(run.additionalData['gewicht'])
          let totalWeightProduced = (run.amountProduced * productWeight) / 1000
          run.productWeight = productWeight
          run.kvahPerKg = run.kvahPerProduct / productWeight * 1000
          run.kvahPerKg = isNaN(run.kvahPerKg) ? 0 : run.kvahPerKg
          run.totalWeightProduced = totalWeightProduced
        } // Get company Config

        run = {
          ...run,
          workflow: this.getWorkflowName(run.workflowId)
        }
        return run
      })

      this.productionRuns = _.orderBy(productionRuns, ['productionStart'], ['desc'])
    },

    async getData() {

      this.$store.commit('setLoading', true)
      let result = await Promise.all([this.getProductionRuns()]).catch(e => {
        this.$store.commit('setLoading', false)
        this.swalError('Something went wrong fetching data')
      })
      this.$store.commit('setLoading', false)

      return this.getExportableData(this.productionRuns)
      // let uniqProductNumbers = _.map(_.uniqBy(this.productionRuns, productionRun => {
      //   return productionRun.additionalData[this.getProductNumberKey];
      // }), uniqueProductNumberRun => {
      //   return uniqueProductNumberRun.additionalData[this.getProductNumberKey]
      // });
      // return uniqProductNumbers//result
    }
  },

}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/desktop/ve-table-desktop.scss";
</style>